import OnlinePaymentTransactionUpdatedResourceModel from '../../generated/types/model/resource/OnlinePaymentTransactionUpdatedResourceModel';

export default class OnlinePaymentTransactionUpdatedResourceViewModel extends OnlinePaymentTransactionUpdatedResourceModel {
  // For instructions on how to use ViewModels visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/155/ViewModels-Models-DTOs
}
